import React from "react";
import "./AboutReadiContent.css";

function AboutReadiContent() {
  return (
    <>
      <div className="about-cards-sec">
        <div className="about-cards-wrap">
          <div
            className="about-cards-row"
            data-aos="zoom-in-right"
            data-aos-delay="0"
          >
            <div className="about-cards-box">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Card-shadow.png"}
                // src="images/Home/Card-shadow.png"
                alt="shadow"
                className="Card-shadow"
              />
              <div className="icon-heading-wrap">
                <div className="icon-heading-row row1">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Home/card-icon1-new.png"
                    }
                    // src="images/Home/card-icon1-new.png"
                    alt="icons"
                    className="heading-icon"
                  />
                </div>
                <div className="icon-heading-row row2">
                  {/* <h3>Scarcity of Right Skilled Workforce</h3> */}
                  <h3>High Multiskilled Demands</h3>
                </div>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/Home/gradient-underline-new.png"
                }
                // src="images/Home/gradient-underline-new.png"
                alt="underline"
                className="gradient-underline"
              />
              <ul className="about-bullets">
                <li>
                  {/* Demand is outpacing supply, especially for future skills. */}
                  Growing need for individuals with a wide range of skills,
                  reflecting a trend towards high multiskilled demands.
                </li>
                <li>
                  {/* <span>Lead time</span> for fulfilling new role/ replacement is
                  high risk of 'knowledge drain'. */}
                  Increased demand for professionals proficient in multiple
                  areas, highlighting the importance of diverse skill sets.
                </li>
              </ul>
            </div>
          </div>

          <div
            className="about-cards-row"
            data-aos="zoom-in-up"
            data-aos-delay="1000"
          >
            <div className="about-cards-box">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Card-shadow.png"}
                // src="images/Home/Card-shadow.png"
                alt="shadow"
                className="Card-shadow"
              />
              <div className="icon-heading-wrap">
                <div className="icon-heading-row row1">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Home/card-icon2-new.png"
                    }
                    // src="images/Home/card-icon2-new.png"
                    alt="icons"
                    className="heading-icon"
                  />
                </div>
                <div className="icon-heading-row row2">
                  {/* <h3>Opportunity, Future Ready</h3> */}
                  <h3>Increasing Complexity of Skill Combinations</h3>
                </div>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/Home/gradient-underline-new.png"
                }
                // src="images/Home/gradient-underline-new.png"
                alt="underline"
                className="gradient-underline"
              />
              <ul className="about-bullets">
                <li>
                  {/* <span>Accelerated digitization</span> of Vodafone Talent
                  Academy. */}
                  Rapidly evolving skills and technologies create a complex
                  skill landscape.
                </li>
                <li>
                  Growing demand for cross-disciplinary skills adds complexity
                  to individual skill profiles.
                </li>
              </ul>
            </div>
          </div>

          <div
            className="about-cards-row"
            data-aos="zoom-in-left"
            data-aos-delay="2000"
          >
            <div className="about-cards-box">
              <img
                src={process.env.PUBLIC_URL + "/images/Home/Card-shadow.png"}
                // src="images/Home/Card-shadow.png"
                alt="shadow"
                className="Card-shadow"
              />
              <div className="icon-heading-wrap">
                <div className="icon-heading-row row1">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Home/card-icon3-new.png"
                    }
                    // src="images/Home/card-icon3-new.png"
                    alt="icons"
                    className="heading-icon"
                  />
                </div>
                <div className="icon-heading-row row2">
                  <h3>Create Talent Pool</h3>
                </div>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/Home/gradient-underline-new.png"
                }
                // src="images/Home/gradient-underline-new.png"
                alt="underline"
                className="gradient-underline"
              />
              <ul className="about-bullets">
                <li>
                  {/* <span>Academy for learning</span> */}A holistic learning
                  program to develop a workforce ready for future skills.
                </li>
                <li>
                  {/* Comprehensive learning program to
                  <span> create future skill ready workforce</span> */}
                  Accelerate digitalization of Vodafone Talent Academy
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutReadiContent;
